export default url => url.split('/').pop();
